'use client'

import { useEffect } from 'react'
import { REACT_APP_ENV, REVIVE_ID } from '../constants'
import { useAds } from './ads-context'

// import { useEffect } from 'react'

interface ReviveAdsProps {
  zoneId: string
  reviveId: string
  className?: string
}

declare global {
  interface Window {
    reviveAsync: {
      [reviveId: string]: {
        refresh: () => void
        seq: number
      }
    }
  }
}

const ReviveAds = ({ zoneId, reviveId, className }: ReviveAdsProps) => {
  const { isAdsActive } = useAds()
  const scriptSrc = '//servedby.revive-adserver.net/asyncjs.php'
  const ReviveId = reviveId || REVIVE_ID

  useEffect(() => {
    // Check if ads are active
    if (!isAdsActive) return

    try {
      const existingScript = document.querySelector(`script[src="${scriptSrc}"]`)
      if (!existingScript) {
        const script = document.createElement('script')
        script.src = scriptSrc
        script.async = true
        script.onload = () => {
          if (typeof window?.reviveAsync?.[reviveId]?.refresh === 'function') {
            window?.reviveAsync[reviveId].refresh()
          }
        }
        document.body.appendChild(script)
      }
    } catch (error) {
      console.log('Error while adding revive script:', error)
    }
  }, [isAdsActive])

  if (REACT_APP_ENV === 'development' || !isAdsActive) return null

  return <ins className={className} data-revive-zoneid={zoneId} data-revive-id={ReviveId}></ins>
}

export default ReviveAds
